import type { TFunction } from 'i18next';

import type { IApiInvitationStatus } from '~/lib/api/modules/Invitations';

export const getInvitationStatusLabel = (
  status: IApiInvitationStatus | 'expired',
  t: TFunction<'translation', undefined>,
): string => {
  switch (status) {
    case 'pending':
      return t(`OrganizationInvitationListItem.status.pending`);
    case 'accepted':
      return t(`OrganizationInvitationListItem.status.accepted`);
    case 'declined':
      return t(`OrganizationInvitationListItem.status.declined`);
    case 'canceled':
      return t(`OrganizationInvitationListItem.status.canceled`);
    case 'expired':
      return t(`OrganizationInvitationListItem.status.expired`);
  }
};
